<template>
  <div class="home-view internal">
    <section class="form">
      <div class="container">
        <h1 class="title-default">Envio de mensagem <span>Envie aqui sua solicitação, reclamação ou elogio. Você receberá uma resposta<br> no e-mail cadastrado (<strong>{{ $store.state.email }}</strong>)</span></h1>

        <form @submit.prevent="envia()">
          <fieldset>
            <textarea required placeholder="Nova mensagem" v-model="model.conteudo"></textarea>
          </fieldset>

          <fieldset class="submit alignright">
            <button type="submit" class="btn" :disabled="loading">{{ loading ? 'Enviando...' : 'Enviar' }}</button>
          </fieldset> <!-- /.submit -->

          <transition name="fade" mode="out-in">
            <h6 class="aligncenter" :class="{ 'color-yellow': $store.state.contratoAtual.marca === 'vibra' }" v-if="success">Enviado com sucesso!</h6>
          </transition>
        </form> <!-- /form -->
      </div> <!-- /.container -->
    </section> <!-- /.form -->
  </div>
</template>

<script>
import PagesService from '@/services/Pages'

export default {
  name: 'envio-mensagem',

  data () {
    const data = {
      loading: false,
      success: false,

      model: {
        id: 0,
        codigoCliente: '',
        nomeCliente: '',
        cpfCliente: '',
        emailCliente: '',
        empreendimentoId: 0,
        unidade: '',
        conteudo: ''
      }
    }

    return data
  }, // data()

  mounted () {
    this.model.codigoCliente = this.$store.state.codigoCliente
    this.model.nomeCliente = this.$store.state.nome
    this.model.cpfCliente = this.$store.state.documento
    this.model.emailCliente = this.$store.state.email

    this.model.empreendimentoId = this.$store.state.contratoAtual.empreendimentoIdWeb

    let { bloco, unidade } = this.$store.state.contratoAtual
    this.model.unidade = `${bloco} - ${unidade}`
  }, // mounted()

  methods: {
    async envia () {
      if (this.loading) return

      this.loading = true
      this.success = false

      try {
        let xhr = await PagesService.enviaMensagem(this.model)
      } catch (e) {
        console.error('Falha ao enviar mensagem', e)
      }

      this.loading = false
      this.success = true
      this.model.conteudo = ''

      setTimeout(() => {
        this.success = false
      }, 4000)
    } // envia()
  }, // methods

  computed: {
  } // computed
}
</script>

<style lang="sass" scoped>
  @import '@/assets/sass/_base.sass'

  .main-view.-vibra
    fieldset.submit button
      background-color: map-get($colors, vibra)

  section
    &.form form
      padding: 25px 33px

      h3
        span
          font-weight: 700
          color: #292929

      textarea
        background-color: map-get($colors, bg_body)
        border-radius: 0
        font-style: normal
        font-size: 15px
        font-family: 'Arial', sans-serif

      fieldset
        &.submit
          display: flex
          justify-content: flex-end

          .btn
            width: 189px
            height: 46px
            font-weight: 700
            font-size: 22px

    @media (max-width: 1024px)
      &.form form
        padding: 20px

    @media (max-width: 767px)
      &.form form
        padding: 20px 15px

        .btn
          width: 100% !important
          font-size: 18px !important
</style>
